import type { ParameterRef } from "./parameter";

export function isParameterRef(v: unknown): v is ParameterRef {
  return typeof v === "object" && v !== null && "type" in v && (v as ParameterRef).type === "PARAMETER_REF";
}
